import { EddingGameCard } from '../../components';
import { useEffect, useState } from 'react';
import { IGameCard } from '../../types';
import { initialGameCardState } from '../CreateGameCardPage/CreateGameCardPage';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { useLocation } from 'react-router-dom';
import { fetchCardGame } from '../../store/gamesSlice';

const GameCardEdingPage = ({ logOut }: { logOut: () => void }) => {
  const [card, setCard] = useState<IGameCard | null>(initialGameCardState);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState<boolean>(false);

  const onGetGameGard = async () => {
    setLoading(true);
    const response = await dispatch(fetchCardGame(queryParams.get('id') as string));
    setCard(response.payload.data);
    setLoading(false);
  };

  useEffect(() => {
    onGetGameGard();
  }, []);

  return (
    <EddingGameCard
      logOut={logOut}
      action="edit"
      card={card || initialGameCardState}
      loading={loading || !card}
    />
  );
};

export default GameCardEdingPage;
